<template>
    <div class="col-md-6">
        <BaseBoxSection :helpName="helpName" :title="__('attachments')">
            <div class="col-12">
                <div v-if="files.length > 0" class="form-group row m-b-none">
                    <div class="col-md-6">
                        <label>{{ __('attachment') }}{{ isRequiredDesignation('attachment') }}</label>
                    </div>
                    <div class="col">
                        <label>{{ __('document_attachment_name') }}{{
                                isRequiredDesignation('attachment_name')
                            }}</label>
                    </div>
                    <div class="col-md-auto">
                        <label></label>
                    </div>
                </div>

                <AttachmentRow
                    v-for="(file, index) in files"
                    :key="index"
                    :disabled="disabled"
                    :downloadLink="downloadLink"
                    :errors="errors"
                    :file="file"
                    :index="index"
                    :permissionsAccess="permissionsAccess"
                    @delete="$emit('removeAttachment', index)"
                    @inputs="$emit('inputs', {index, ...$event})"
                />

            </div>

            <div class="col-12">
                <button v-if="!disabled" class="btn btn-primary" type="button" @click="$emit('addNewFile')">
                    <i class="fa fa-plus"></i> {{ __('add_attachment') }}
                </button>
            </div>
        </BaseBoxSection>
    </div>
</template>

<script>
import BaseBoxSection from "../BaseBoxSection";
import hasPermissions from "../../mixins/hasPermissions";
import AttachmentRow from "./AttachmentRow";
import inputEmit from "../../mixins/inputEmit";
import hasErrors from "../../mixins/hasErrors";
import hasRequiredFields from "../../mixins/hasRequiredFields";

export default {
    name: "AttachmentsBox",
    components: {AttachmentRow, BaseBoxSection},
    mixins: [hasPermissions, inputEmit, hasErrors, hasRequiredFields],
    props: {
        files: {
            type: Array,
            required: true,
        },
        downloadLink: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        helpName: {
            type: String,
            required: true,
        },
    },
};
</script>

